import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate} from "react-router-dom";
import * as Agency from "../index";
import {AgencyPrepareAddFormResponse} from "../../../types/modules/agency/response";
import {StoreContext} from "../../../store.context";

export const Add: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { agencyStore: { add }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();

    const data: AgencyPrepareAddFormResponse = useLoaderData() as AgencyPrepareAddFormResponse;

    const onCancel = () => {
        navigate(`/agency`)
    }

    return <Agency.Form onSave={add} onCancel={onCancel} preparedData={data} />
})